import { InjectionToken, inject } from '@angular/core';

import { DYNAMIC_INJECTOR_PROVIDER_TOKEN, IDynamicInjectorProvider } from './dynamic-injector.provider';

// Using Function type here as this is accurate for this util.
export const NonRootToken = <T>(t: Function | InjectionToken<T>): InjectionToken<T> => {
    const name = t instanceof InjectionToken ? t.toString() : t.name;

    return new InjectionToken<T>(`DynamicRootFor_${name}`, {
        providedIn: 'root',
        factory: () => inject<IDynamicInjectorProvider>(DYNAMIC_INJECTOR_PROVIDER_TOKEN).getDynamicInjector().get<T>(t),
    });
};

// Using Function type here as this is accurate for this util.
export const OptionalNonRootToken = <T>(t: Function | InjectionToken<T>): InjectionToken<T | null> => {
    const name = t instanceof InjectionToken ? t.toString() : t.name;

    return new InjectionToken<T | null>(`OptionalDynamicRootFor_${name}`, {
        providedIn: 'root',
        factory: () => inject<IDynamicInjectorProvider>(DYNAMIC_INJECTOR_PROVIDER_TOKEN).getDynamicInjector().get<T>(t, null, { optional: true }),
    });
};
